import * as THREE from 'three'
import Experience from './Experience.js'

// prova SOBEL C:\webserver\WP-URBAN3D-BS\node_modules\three\examples\jsm\postprocessing\GlitchPass.js
// import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
// import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
// import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

// import { LuminosityShader } from 'three/examples/jsm/shaders/LuminosityShader.js';
// import { OutlineEffect } from 'three/examples/jsm/effects/OutlineEffect.js';

// import { SobelOperatorShader } from 'three/examples/jsm/shaders/SobelOperatorShader.js';
// fine sobel


export default class Renderer
{
    constructor()
    {
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera

        this.setInstance()
    }

    setInstance()
    {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            alpha:true
        })
        this.instance.physicallyCorrectLights = true
        this.instance.outputEncoding = THREE.sRGBEncoding
        // this.instance.toneMapping = THREE.CineonToneMapping
        this.instance.toneMappingExposure = 1
        // this.instance.shadowMap.enabled = true
        // this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        // this.instance.setClearColor('#ffffff')
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio,1))
        // this.instance.setPixelRatio(1)
// prova SOBEL
        // this.enableSobel=false
        // this.composer = new EffectComposer( this.instance );
        // this.renderPass = new RenderPass( this.scene, this.camera.instance );
        // this.composer.addPass( this.renderPass );

        // // color to grayscale conversion

        // this.effectGrayScale = new ShaderPass( LuminosityShader );
        // this.composer.addPass( this.effectGrayScale );

        // // you might want to use a gaussian blur filter before
        // // the next pass to improve the result of the Sobel operator

        // // Sobel operator
        // // this.outline = new OutlineEffect(this.instance,{defaultThickness:0.01})
        // this.effectSobel = new ShaderPass( SobelOperatorShader );
        // this.effectSobel.uniforms[ 'resolution' ].value.x = window.innerWidth * window.devicePixelRatio;
        // this.effectSobel.uniforms[ 'resolution' ].value.y = window.innerHeight * window.devicePixelRatio;
        // this.composer.addPass( this.effectSobel );


    }

    resize()
    {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, 2))
    }

    update()
    {  
        // if ( this.enableSobel === true ) {

        //     this.composer.render();
        //     // this.outline.render(this.scene,this.camera.instance)

        // } else {

        //     this.instance.render(this.scene, this.camera.instance)

        // }
        this.instance.render(this.scene, this.camera.instance)
    }
}